import React, { Fragment, Suspense } from "react";
import Preloader from "../Components/common/Preloader";
const Breadcrumb = React.lazy(() => import("../Components/Breadcrumb"));
const Reports = React.lazy(() => import("../Components/Reports"));
const SearchPopup = React.lazy(() =>
  import("../Components/common/SearchPopup")
);
const Report = () => {
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />
          {/* Breadcrumb */}
          <Breadcrumb title={"گزارشات"} />

          {/* Service Details Inner */}
          <Reports />
        </Suspense>
      </Fragment>
    </>
  );
};

export default Report;
